<div class="u-shadow-mini  {{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
				<span *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
			<div class="social-demographic-gender-list-cntr" *ngIf="legend">
				<ul>
					<li
						*ngFor="let metric of legend; let index = index"
						class="social-demographic-gender-list-item"
						[ngClass]="{ activeMetric: activeIndex === index }"
						(click)="setMetricData(metric['value'], index)"
					>
						{{ metric['displayName'] }}
					</li>
				</ul>
			</div>
		</div>
		<div class="analytics-portlet-content">
			<div class="o-stack o-stack--nowrap o-stack--center" *ngIf="hasData">
				<div class="chart-legend">
					<div class="chart-legend">
						<div class="legend-div legend-width">
							<div (click)="updateChartData('female')" class="label-container">
								<div class="labels" [ngClass]="{ 'primary-color-bg': femaleState }"></div>
								<span [ngClass]="{ 'label-text': true, 'selected-legend': femaleState }">Female</span>
							</div>
							<div (click)="updateChartData('male')" class="label-container">
								<div class="labels" [ngClass]="{ 'secondary-color-bg': maleState }"></div>
								<span [ngClass]="{ 'label-text': true, 'selected-legend': maleState }">Male</span>
							</div>
							<div (click)="updateChartData('unknown')" class="label-container">
								<div class="labels" [ngClass]="{ 'tertiary-color-bg': unknownState }"></div>
								<span [ngClass]="{ 'label-text': true, 'selected-legend': unknownState }">Unknown</span>
							</div>
						</div>
						<div class="legend-div total-div">
							<span>Total {{ legend[activeIndex].displayName }} : {{ overallTotal | number }}</span>
						</div>
					</div>
					<div *ngIf="femaleState || maleState || unknownState">
						<div *ngFor="let donutData of newChartArrData; let index = index" class="donut-carousel-container">
							<div class="donut-container-elem">
								<app-donut [chartData]="donutData" [chartConfigurationObj]="chartConfigObj"></app-donut>
							</div>
							<div class="gender-donut-label">
								<b>Ages<br />{{ ageArray[index].ageGroup }}</b>
							</div>
							<div class="gender-icon">
								{{ ageArray[index].total | number }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="map-no-data" *ngIf="!hasData">No Data to Display</div>
		</div>
	</div>
</div>
